// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uCa+2","large":"styles_large__2NqdY"};